export const formatDateTime = (
  dateString: string,
  showSeconds: boolean = true
) => {
  const date = new Date(dateString);

  const currentDayStart = new Date();
  currentDayStart.setHours(0, 0, 0, 0); // Начало суток

  const diffTime = currentDayStart.getTime() - date.getTime(); // мс прошло с начала суток

  const optionsTime: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    ...(showSeconds && { second: "2-digit" }),
  };
  const optionsDate: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  if (diffTime < 0) {
    // Если отрицаельное значение, то сегодня
    return `Сегодня ${date.toLocaleTimeString(undefined, optionsTime)}`;
  } else if (diffTime <= 1000 * 60 * 60 * 24) {
    // Прошло не более суток до начала текущего дня
    return `Вчера ${date.toLocaleTimeString(undefined, optionsTime)}`;
  } else {
    return `${date.toLocaleDateString(
      undefined,
      optionsDate
    )} ${date.toLocaleTimeString(undefined, optionsTime)}`;
  }
};

export const formatDateToYYYYMMDD = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const isValidDate = (date: any): boolean => {
  return date instanceof Date && !isNaN(date.valueOf());
};

export const formatDate = (dateStr: any): string => {
  if (dateStr) {
    let date = new Date(dateStr);
    if (isValidDate(date)) {
      return date.toLocaleDateString();
    }
  }
  return "";
};

export const formatDates = (
  firstDate: string | undefined,
  secondDate: string | undefined
) => {
  const startedDate = formatDate(firstDate);
  const finishedDate = formatDate(secondDate);

  if (startedDate && finishedDate) {
    return `${startedDate} - ${finishedDate}`;
  } else if (startedDate) {
    return `${startedDate}`;
  } else if (finishedDate) {
    return `${finishedDate}`;
  }
  return "";
};

export function formatDateTimeSimplified(value: string | number | Date): string {
  if (!value) return "";
  return new Date(value).toLocaleString("ru-RU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}